'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _class, _class2, _temp;

var _reactRedux = require('react-redux');

var _reactAutocomplete = require('react-autocomplete');

var _reactAutocomplete2 = _interopRequireDefault(_reactAutocomplete);

var _catalog = require('redux/actions/catalog');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    AutocompleteSearch: {
        displayName: 'AutocompleteSearch'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/Search/Autocomplete/index.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var TIMEOUT_AJAX = 300;

var AutocompleteSearch = _wrapComponent('AutocompleteSearch')((_dec = (0, _reactRedux.connect)(function (state) {
    return {
        searchProducts: state.catalog.searchProducts,
        searchLoaded: state.catalog.searchLoaded,
        closeSearch: state.catalog.closeSearch
    };
}, { searchProductsAction: _catalog.searchProducts, resetSearchProducts: _catalog.resetSearchProducts, setSearchClose: _catalog.setSearchClose }), _dec(_class = (_temp = _class2 = function (_Component) {
    (0, _inherits3.default)(AutocompleteSearch, _Component);

    function AutocompleteSearch(props, context) {
        (0, _classCallCheck3.default)(this, AutocompleteSearch);

        var _this = (0, _possibleConstructorReturn3.default)(this, (AutocompleteSearch.__proto__ || (0, _getPrototypeOf2.default)(AutocompleteSearch)).call(this, props, context));

        _this._isEscapePressed = false;

        _this.ajax = function (value) {
            _this.props.searchProductsAction(value);
        };

        _this.timeoutAjax = function (value) {
            _this.cleanTimeoutAjax();
            _this._setTimeOut = setTimeout(function () {
                _this.ajax(value);
            }, TIMEOUT_AJAX);
        };

        _this.cleanTimeoutAjax = function () {
            if (_this._setTimeOut) {
                clearTimeout(_this._setTimeOut);
            }
        };

        _this.onChange = function (event, value) {
            if (_this._isEscapePressed === true) {
                _this._isEscapePressed = false;
                _this.cleanTimeoutAjax();
                return;
            }

            if (value.length === 0) {
                _this.props.resetSearchProducts();
            }

            _this.setState({ search: value });
            if (value.length > 0) {
                _this.timeoutAjax(value);
            }

            if (_this.props.onChange) {
                _this.props.onChange(value);
            }
        };

        _this.onSelect = function (value, item) {
            _this.setState({ search: value });
            _this.props.resetSearchProducts();
            if (_this.props.onSelect) {
                _this.props.onSelect(value);
            }
        };

        _this.onKeyDown = function (event) {
            if (event.key === 'Escape') {
                _this._isEscapePressed = true;
            }
        };

        _this.state = {
            search: '',
            isShow: false
        };
        return _this;
    }

    (0, _createClass3.default)(AutocompleteSearch, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var _this2 = this;

            if (nextProps.closeSearch) {
                //Сброс инпута после выхода со страницы поиска
                this.setState({ search: '' }, function () {
                    _this2.props.setSearchClose(false);
                });
            }
            if (nextProps.hasOwnProperty('searchLoaded') && this.props.loader) {
                if (this.props.searchLoaded === false && nextProps.searchLoaded === true) {
                    this.props.loader.style.display = 'inline-block';
                } else if (this.props.searchLoaded === true && nextProps.searchLoaded === false) {
                    this.props.loader.style.display = 'none';
                }
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var inputProps = {
                onKeyDown: this.onKeyDown
            };

            if (this.props.classNameInput) {
                inputProps.className = this.props.classNameInput;
            }
            if (this.props.placeholderInput) {
                inputProps.placeholder = this.props.placeholderInput;
            }
            if (this.props.onKeyPress) {
                inputProps.onKeyPress = this.props.onKeyPress;
            }
            if (this.props.typeInput) {
                inputProps.type = this.props.typeInput;
            }

            var wrapperClassName = 'search-wrapper';
            if (this.state.isShow) {
                wrapperClassName += ' show';
            }

            return _react3.default.createElement(_reactAutocomplete2.default, {
                value: this.state.search,
                items: this.props.searchProducts || [],
                inputProps: inputProps,
                wrapperProps: {
                    className: wrapperClassName
                },
                onMenuVisibilityChange: function onMenuVisibilityChange(isOpen) {
                    _this3.setState({ isShow: isOpen }, function () {
                        _this3.props.onShow(isOpen);
                    });
                    if (isOpen === false) {
                        _this3.props.resetSearchProducts();
                    }
                },
                renderMenu: function renderMenu(items, value, style) {
                    return _react3.default.createElement(
                        'div',
                        { className: 'search-menu-wrapper' },
                        _react3.default.createElement('div', { className: _this3.props.classMenu + ' ' + (items.length ? '' : 'no_border'), children: items })
                    );
                },
                onChange: this.onChange,
                onSelect: this.onSelect,
                getItemValue: function getItemValue(item) {
                    return item.name;
                },
                renderItem: function renderItem(item, isHighlighted) {
                    return _react3.default.createElement(
                        'div',
                        {
                            className: 'search-item' + (isHighlighted ? ' highlighted' : ''),
                            key: item.id,
                            id: item.id
                        },
                        item.name
                    );
                }
            });
        }
    }]);
    return AutocompleteSearch;
}(_react2.Component), _class2.propTypes = {
    searchProducts: _react2.PropTypes.array,
    searchLoaded: _react2.PropTypes.bool,
    searchProductsAction: _react2.PropTypes.func,
    resetSearchProducts: _react2.PropTypes.func,
    onChange: _react2.PropTypes.func,
    onSelect: _react2.PropTypes.func,
    classNameInput: _react2.PropTypes.string,
    placeholderInput: _react2.PropTypes.string,
    typeInput: _react2.PropTypes.string,
    onKeyPress: _react2.PropTypes.func,
    classMenu: _react2.PropTypes.string,
    loader: _react2.PropTypes.any,
    onShow: _react2.PropTypes.func
}, _class2.defaultProps = {
    searchLoaded: false,
    searchProducts: [],
    classMenu: '',
    loader: null,
    onShow: function onShow() {}
}, _temp)) || _class));

exports.default = AutocompleteSearch;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Search/Autocomplete/index.jsx
// module id = 1760
// module chunks = 0